import { render } from "./SchedulesDetailsSetupTab.vue?vue&type=template&id=305daf15&scoped=true"
import script from "./SchedulesDetailsSetupTab.vue?vue&type=script&lang=js"
export * from "./SchedulesDetailsSetupTab.vue?vue&type=script&lang=js"

import "./SchedulesDetailsSetupTab.vue?vue&type=style&index=0&id=305daf15&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-305daf15"]])

export default __exports__